module.exports = __webpack_public_path__ + "static/media/ag-fc-court-sample-splash.2bb07e72.png";